import { useMemo, useState } from "react";
import { IoWalletOutline } from "react-icons/io5";
import { FaShoppingCart, FaReceipt, FaCoins } from "react-icons/fa";

import { PageShell, PageHeader, DetailTabs } from "../../../Components/shared";
import WalletTopupPage from "../../walletTopup/storageRoles/WalletTopupPage";
import SalesPage from "../../sales/storageRoles/SalesPage";
import MachineRecordsPage from "../../machineRecords/storageRoles/MachineRecordsPage";
import OkkaliraRateCard from "../../../Components/wallet/OkkaliraRateCard";
import usePermission from "../../../Hooks/usePermission";

/**
 * Ödemeler — makineden kart/QR ile uygulama üzerinden alınan ödemelerin tek
 * çatısı. Önce üç ayrı menü öğesiydi (Bakiye Yükleme / Satış / Makine
 * Kayıtları); aynı para akışının farklı görünümleri oldukları için sekmeye
 * dönüştürüldü.
 *
 * Alt sayfalar `embedded` ile çağrılır: kendi PageShell'lerini kurmaz, kabuk
 * burada; kendi başlık + istatistik blokları sekme içinde kalır.
 */
const TABS = [
  {
    id: "topup",
    label: "Bakiye Yükleme",
    icon: IoWalletOutline,
    bg: "bg-emerald-500",
  },
  // "Satış / İade": FİNANS menüsündeki "Satış" (fatura bazlı satış
  // dashboard'u) ile karışmasın — burası makineden alınan ödemeler.
  {
    id: "sales",
    label: "Satış / İade",
    icon: FaShoppingCart,
    bg: "bg-indigo-500",
  },
  {
    id: "records",
    label: "Makine Kayıtları",
    icon: FaReceipt,
    bg: "bg-amber-500",
  },
];

// Okkalira kuru sekmesi — ayrı izinle (#400)
const OKKALIRA_TAB = { id: "okkalira", label: "Okkalira", icon: FaCoins, bg: "bg-amber-500" };

function PaymentsPage() {
  const [activeTab, setActiveTab] = useState("topup");
  const { hasPermission } = usePermission();
  const canOkkaliraRate = hasPermission("wallet.okkaliraRate");
  const tabs = useMemo(() => (canOkkaliraRate ? [...TABS, OKKALIRA_TAB] : TABS), [canOkkaliraRate]);

  return (
    <PageShell>
      <div className="px-3 py-2.5 sm:p-4 md:px-6 md:py-4 bg-gray-50/80 sm:bg-gray-50 shrink-0">
        <PageHeader
          icon={IoWalletOutline}
          iconColor="emerald"
          title="Ödemeler"
          subtitle="Makinelerden kart/QR ile alınan ödemeler"
        />
      </div>

      <DetailTabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />

      {activeTab === "topup" && <WalletTopupPage embedded />}
      {activeTab === "sales" && <SalesPage embedded />}
      {activeTab === "records" && <MachineRecordsPage embedded />}
      {activeTab === "okkalira" && canOkkaliraRate && (
        <div className="p-3 sm:p-4 md:p-6 overflow-y-auto">
          <OkkaliraRateCard />
        </div>
      )}
    </PageShell>
  );
}

export default PaymentsPage;
